import Button from "@src/components/UIElements/Button";
import Modal from "@src/components/UIElements/Modal";
import { Image } from "@src/components/Image";
import React from "react";
import styles from "./EnrollForFreeCourseBottomSheet.module.scss";
import { useDispatch, useSelector } from "react-redux";
import * as actionCreator from "../../store/actions";
import { useTranslation } from "react-i18next";
import { enrollOnFreeCourse } from "@src/PaymentService/enrollForFreeCourse";

const EnrollForFreeCourseBottomSheet = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const state = useSelector(
    (state) => state?.bottomSheetReducer?.showEnrollForFreeCourseBottomSheetAction
  );

  const courseId = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.metaData?.id
  );

  function handleGoBackInstead(){
      dispatch(actionCreator.showEnrollForFreeCourseBottomSheetAction(false));    
  }
  
  return (
    <Modal
      showModal={state}
      handleClose={() => {
        dispatch(actionCreator.showEnrollForFreeCourseBottomSheetAction(false));
      }}
      isCloseButtonVisible={false}
    >
      <div className={styles.FreeCourse}>
        <div className={styles.FreeCourse__image}>
          <Image
            src={"https://cdn-wl-assets.classplus.co/frontend-assets/exclamation-mark.svg"}
            alt={t(
              "components.bottomSheets.components.freeTrialBottomSheet.rupeeIcon",
              "RupeeIcon"
            )}
            width="64px"
            height="64px"
          />
        </div>
        <h1 className={styles.FreeCourse__heading}>
          {t(
            "components.bottomSheets.components.enrollForFreeCourseBottomSheet.thisIsAFreeCourse",
            "This is a FREE course"
          )}
        </h1>
        <p className={styles.FreeCourse__subtext}>
          {
          t(
            "components.bottomSheets.components.enrollForFreeCourseBottomSheet.oneFreeCourseAtaTime",
            "This course can be enrolled once in a month. Only 1 course can be active at once"
          )}
        </p>
        <Button
          onClick={() => enrollOnFreeCourse(courseId)}
          customClassName={styles.FreeCourse__btnColor}
        >
          {t(
            "components.bottomSheets.components.enrollForFreeCourseBottomSheet.enrollForFree",
            "Enroll Now for FREE"
          )}
        </Button>
        <p className={styles.FreeCourse__goBackInsteadBtn} onClick={handleGoBackInstead}>
          {t(
            "components.bottomSheets.components.enrollForFreeCourseBottomSheet.goBackInstead",
            "Go back instead"
          )}
        </p>
      </div>
    </Modal>
  );
};

export default EnrollForFreeCourseBottomSheet;
